import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_005.jpg';

page.games = [
  {
    id: 'page005_game1',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 5',
    pos: {
      x: RIGHT,
      y: 40,
    },
    items: [
      {
        id: 'page005_game1',
      },
      {
        id: 'page005_game2',
      },
      {
        id: 'page005_game3',
      },
      {
        id: 'page005_game4',
      },
      {
        id: 'page005_game5',
      },
    ],
  },
];

export default page;
